import Vue from 'vue'
// NOTE
// all parent must be have "position: relative"
Vue.directive('autoscroll', (el: Element, bindings: any, vnode) => {
  setTimeout(() => {
    const rect = el.getBoundingClientRect()
    let offset = 0
    const getFirstScrolalbleParent = (el: Element): Element | null => {
      if (el.classList.contains('scroll') || el.classList.contains('scroll-area')) {
        return el
      }
      // @ts-ignore
      offset += el.offsetTop
      if (el.parentElement) {
        return getFirstScrolalbleParent(el.parentElement)
      }
      return null
    }
    const scrollableParent = getFirstScrolalbleParent(el)
    const isVisible = () => {
      if (scrollableParent) {
        if (scrollableParent.scrollTop + scrollableParent.clientHeight >= offset + rect.height) {
          return true
        }
      }
      return false
    }
    if (scrollableParent) {
      if (!isVisible()) {
        if (bindings.value === 'visible') {
          scrollableParent.scrollTop += rect.height
        }
      }
    }
  }, 200)
})
